import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { getOr, isEmpty } from 'lodash/fp';

import api from './api';

const name = 'businessLead';

const submitBusiness = createAsyncThunk(
  'businessLead/submitBusiness',
  async (payload) => {
    const response = api.post(payload);

    return response;
  }
);

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      isLoading: false,
      data: {},
      error: false,
    },
    extraReducers: (builder) => {
      builder
        .addCase(submitBusiness.pending, (state) => {
          state.isLoading = true;
          state.error = {};
        })
        .addCase(submitBusiness.fulfilled, (state, action) => {
          state.data = action.payload;
          state.isLoading = false;
        })
        .addCase(submitBusiness.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        });
    },
  }),
};

const selectors = {};

export default {
  actions: {
    ...actions,
    submitBusiness,
  },
  selectors,
  reducer,
  name,
};
